/**
 * M4.V5 — the Timeline view (`specs/M4-V5-timeline.md`).
 *
 * monday's Timeline **is** its Gantt with a 232 px side panel and no *Baseline* button; both
 * store the identical nine `settings_str` keys and both mount the same `.react-timeline-container`
 * `[cap:views/INDEX.md]`. So this is the whole renderer: a second component would be inventing
 * a difference that does not exist, and the spec says so in §1 to stop anyone "finishing" it.
 */
import type { GanttViewSettings } from '@elizmonday/shared';
import { GanttView, TIMELINE_CHROME } from '../gantt/GanttView';
import type { BoardDataSource } from '../../board-view/data/types';
import type { ViewSettingsOverride } from '../shared/use-view-settings';

export interface TimelineViewProps {
  boardId: string;
  viewId: string;
  source: BoardDataSource;
  settingsOverride?: ViewSettingsOverride<GanttViewSettings>;
  today?: string;
}

export function TimelineView(props: TimelineViewProps) {
  return <GanttView {...props} kind="timeline" chrome={TIMELINE_CHROME} />;
}
